/**
 * Feature flag: MetaTrader (MetaAPI) broker sync connection.
 *
 * Temporarily disabled while the feature is finalised. When `false`:
 *  - the "MetaTrader" account-type tile is greyed out + flagged "Soon"
 *  - every "Connect MetaTrader" entry point is hidden
 *  - the `connectMetaApiAccount` server op rejects new connections (403)
 *
 * This flag only gates the creation of NEW connections. Flip to `true`
 * to restore the connect flow in a single place.
 *
 * Client-safe (no wasp/server imports) so both UI and the server op can
 * import the same intent.
 */
export const METATRADER_SYNC_CONNECT_ENABLED = false;

/**
 * Feature flag: MetaTrader (MetaAPI) background sync.
 *
 * Séparé de METATRADER_SYNC_CONNECT_ENABLED : couper les NOUVELLES connexions
 * ne coupait pas les crons PgBoss, qui continuaient à ramasser les
 * MetaApiConnection résiduelles en base et à taper l'API MetaAPI.
 *
 * Incident 2026-08-25 : `enable-metastats-api → HTTP 404 Trading account with
 * id 2906 not found` levé par la fenêtre de deploy, sur une connexion dont le
 * terminal n'existait plus côté MetaAPI. Personne ne pouvait plus connecter de
 * compte MetaTrader, mais les jobs tournaient toujours.
 *
 * Quand `false`, les jobs metaApiDeployJob / metaApiSyncJob / metaApiUndeployJob /
 * metaApiManualPollJob / metaApiInitialSyncJob sortent immédiatement, sans lire
 * la base ni appeler MetaAPI. Les données restent intactes : aucune connexion
 * n'est supprimée ni mutée, la remise à `true` reprend la sync là où elle était.
 *
 * Les jobs restent déclarés dans main.wasp (retirer une déclaration `job` ferait
 * échouer PgBoss sur les jobs déjà en file). On garde donc l'ordonnancement et
 * on coupe le corps.
 */
export const METATRADER_SYNC_ENABLED = false;
